import router from "@/router";
import cookie from '@assets/js/public/Cookie'
import {Dialog, Toast} from "vant"

/**
 * Description:
 * Author: Wangyan
 * Date: 2019-03-04
 * Time: 16:32
 */

/**
 * 首页有openId参数的存入cookie
 */
router.beforeEach((to, from, next) => {
    if (to.name === 'WechatIndex' && to.params.openId) {   // 根据路由name向cookie存入openId
        cookie.setOpenId(to.params.openId)
        next()
    }
    next()
})

/**
 * 更改每一个页面title
 */
router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})

/**
 * 点击浏览器返回时关闭vant组件Dialog与Toast
 */
router.beforeEach((to, from, next) => {
    Dialog.close()
    Toast.clear()
    next()
})
